<section class="w-full rounded-2xl border border-alto bg-white p-6" aria-labelledby="identification-title">
  <header class="mb-5">
    <h3 id="identification-title" class="text-base font-semibold text-casal">Identificação do paciente</h3>
    <p class="text-sm text-shuttle-gray">Como o totem identifica quem vai usar, antes dos módulos.</p>
  </header>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <!-- Navegação anônima -->
    <div class="rounded-xl bg-alto-200 p-4">
      <label class="flex cursor-pointer items-center justify-between gap-4">
        <span class="text-sm font-semibold text-casal">Permitir navegação anônima</span>
        <input type="checkbox" [formControl]="anonymousControl" class="toggle-checkbox hidden" />
        <span class="toggle-switch shrink-0"></span>
      </label>
      <p class="mt-1 text-sm text-shuttle-gray">
        A tela de CPF mostra <strong class="font-semibold text-casal">"Continuar sem CPF"</strong>: se identifica quem
        quiser.
      </p>

      <div
        *ngIf="anonymousAllowed"
        class="mt-3 flex gap-2 rounded-lg border border-downy bg-white p-3 text-sm text-casal"
        role="note"
      >
        <mat-icon class="chip-icon mt-0.5 shrink-0 text-downy-700">info</mat-icon>
        <div class="flex flex-col gap-1">
          <p>
            Quem continuar sem CPF usa o usuário anônimo da empresa: os resultados não entram no histórico de uma
            pessoa.
          </p>
          <p *ngIf="ageGenderModulesText">
            <strong class="font-semibold">{{ ageGenderModulesText }}</strong> perguntam idade e sexo no início da sessão
            anônima.
          </p>
        </div>
      </div>
    </div>

    <!-- Cadastro -->
    <div class="rounded-xl bg-alto-200 p-4" [formGroup]="registrationGroup">
      <label class="flex cursor-pointer items-center justify-between gap-4">
        <span class="text-sm font-semibold text-casal">Cadastro de novos pacientes</span>
        <input type="checkbox" formControlName="enabled" class="toggle-checkbox hidden" />
        <span class="toggle-switch shrink-0"></span>
      </label>
      <p class="mt-1 text-sm text-shuttle-gray">
        {{
          registrationEnabled
            ? 'CPF não encontrado: o totem abre o cadastro com estas telas, nesta ordem.'
            : 'CPF não encontrado: o totem avisa e não abre o cadastro.'
        }}
      </p>

      <ol class="mt-3 flex flex-wrap items-center gap-2" [class.opacity-40]="!registrationEnabled">
        <li *ngFor="let screen of screens; let i = index; let last = last" class="flex items-center gap-2">
          <button
            *ngIf="screen.control; else fixed"
            type="button"
            role="switch"
            class="flex h-8 items-center gap-1 rounded-full border px-3 text-sm font-medium transition-colors"
            [class.border-cerise-red]="phoneEnabled"
            [class.bg-white]="phoneEnabled"
            [class.text-casal]="phoneEnabled"
            [class.screen-chip--off]="!phoneEnabled"
            [class.border-alto-700]="!phoneEnabled"
            [class.text-shuttle-gray]="!phoneEnabled"
            [attr.aria-checked]="phoneEnabled"
            [disabled]="!registrationEnabled"
            [matTooltip]="phoneEnabled ? 'Clique para tirar do cadastro' : 'Clique para pedir no cadastro'"
            (click)="toggleScreen(screen)"
          >
            <mat-icon class="chip-icon">{{ phoneEnabled ? 'check_circle' : 'remove_circle_outline' }}</mat-icon>
            <ng-container *ngIf="screenNumbers[i] as position">{{ position }}. </ng-container>{{ screen.label }}
          </button>
          <ng-template #fixed>
            <span
              class="flex h-8 items-center gap-1 rounded-full border border-alto bg-white px-3 text-sm text-casal"
              [matTooltip]="'Obrigatória: ' + screen.reason"
            >
              <mat-icon class="chip-icon text-alto-700">lock</mat-icon>
              {{ screenNumbers[i] }}. {{ screen.label }}
            </span>
          </ng-template>
          <mat-icon *ngIf="!last" class="chip-icon text-alto-700" aria-hidden="true">chevron_right</mat-icon>
        </li>
      </ol>
      <p class="mt-3 text-xs text-shuttle-gray">
        <mat-icon class="chip-icon align-middle text-alto-700">lock</mat-icon> obrigatória · clique em
        <strong>Celular</strong> para incluir ou tirar.
      </p>
    </div>
  </div>
</section>
